/**
 * Couleurs sémantiques EkynAir — conformité WCAG AA/AAA sur fond clair.
 * Pourquoi : les hex vifs (#10B981, #F59E0B, #EF4444) échouent au
 * contraste AA quand utilisés en color: sur texte. Ces tokens fournissent
 * la version foncée à utiliser systématiquement pour les labels, valeurs,
 * badges et bordures sémantiques visibles sur fond clair.
 *
 * Règle : ne jamais utiliser les *Solid en color: sur du texte.
 * Les *Solid restent réservés aux backgrounds + texte blanc dessus,
 * aux icônes décoratives Chart.js, aux séries de graphique.
 */
export const semanticColors = {
  // Texte sémantique sur fond clair (AAA)
  greenText:  '#047857',  // 6.09:1 sur blanc
  amberText:  '#B45309',  // 5.93:1 sur blanc
  orangeText: '#C2410C',  // 6.43:1 sur blanc
  redText:    '#B91C1C',  // 7.05:1 sur blanc

  // Backgrounds tints (inchangés, à utiliser avec *Text dessus)
  greenBg:  '#D1FAE5',
  amberBg:  '#FEF3C7',
  redBg:    '#FEE2E2',

  // Solides à conserver pour borders épaisses + icônes décoratives
  // chart + backgrounds avec texte blanc (NE PAS utiliser en color: text)
  greenSolid:  '#10B981',
  amberSolid:  '#F59E0B',
  redSolid:    '#EF4444',  // ex-orangeSolid : #EF4444 est un rouge (red-500), pas un orange
};
